import { useState, useEffect } from 'react';
import cadenceGqlCall from 'apps/cadences-v2/utils/cadence-gql-call';

const IMPACT_QUERY = `
  query CadenceDnsDisconnectImpact {
    cadenceDnsDisconnectImpact {
      activeCadencesWithEmail
      scheduledBulkMessages
    }
  }
`;

/**
 * Fetches counts of active cadences (with email steps) and scheduled bulk messages
 * so the disconnect DNS modal can warn owners about downstream impact.
 */
const useDnsDisconnectImpact = (enabled = true) => {
  const [activeCadenceCount, setActiveCadenceCount] = useState(0);
  const [pendingBulkMessageCount, setPendingBulkMessageCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    setLoading(true);
    cadenceGqlCall(IMPACT_QUERY)
      .then((data) => {
        if (cancelled) return;
        const impact = data?.cadenceDnsDisconnectImpact || {};
        setActiveCadenceCount(impact.activeCadencesWithEmail || 0);
        setPendingBulkMessageCount(impact.scheduledBulkMessages || 0);
      })
      .catch(() => {
        // Non-critical — impact counts are informational only
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { activeCadenceCount, pendingBulkMessageCount, loading };
};

export default useDnsDisconnectImpact;
